//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
export default {
  name: 'SiteOnline',
  data: function data() {
    return {
      pagePath: '/comm/api/online',
      pageTitle: '在线站点',
      loading: true,
      dataSource: [],
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 80,
        fixed: 'left',
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'mn',
        title: '站点编号',
        align: 'center'
      }, {
        dataIndex: 'name',
        title: '站点名称',
        align: 'center'
      }, {
        dataIndex: 'connectTime',
        title: '连接时间',
        align: 'center'
      }, {
        dataIndex: 'lastTime',
        title: '最后通讯时间',
        align: 'center'
      }]
    };
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this = this;

      this.loading = true;
      getAction(this.pagePath, {}).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result;
        } else {
          _this.$message.warning('系统异常=>' + res.message);
        }

        _this.loading = false;
      });
    }
  }
};